import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
export class MediaImageLoader extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      // Set state value to equal to current static value of this class.
      MediaImage: MediaImageLoader.MediaImage
    });
  }
  async componentDidMount() {
    if (!this.state.MediaImage) {
      try {
        const [mediaClient, mediaImageModule] = await Promise.all([import( /* webpackChunkName: "@atlaskit-internal_media-client-react" */'@atlaskit/media-client-react'), import( /* webpackChunkName: "@atlaskit-internal_media-image" */'./mediaImage')]);
        const MediaImageWithClient = mediaClient.withMediaClient(mediaImageModule.MediaImageInternal);
        MediaImageLoader.MediaImage = MediaImageWithClient;
        this.setState({
          MediaImage: MediaImageWithClient
        });
      } catch (error) {
        // TODO [MS-2277]: Add operational error to catch async import error
      }
    }
  }
  render() {
    const {
      MediaImage
    } = this.state;
    if (!MediaImage) {
      return this.props.children({
        loading: true,
        error: false,
        data: undefined
      });
    }
    return /*#__PURE__*/React.createElement(MediaImage, this.props);
  }
}
_defineProperty(MediaImageLoader, "displayName", 'AsyncMediaImage');